import { evaluateTierGate, type Tier, type TierGateContext } from '@/lib/modalTiers';
import { type ModalId } from '@heidi/schema/ml-scribe';
import { atom } from 'jotai';
import { MODAL_TIER_REGISTER } from './modalTierRegister';

/**
 * PostHog kill switch mirror for the T0–T5 tier framework, fed by
 * `ModalTierFrameworkSync`. Default false until PostHog resolves.
 */
export const isModalTierFrameworkEnabledAtom = atom(false);

/**
 * Dev-tools-only local override for the framework enable state, honoured by
 * `ModalTierFrameworkSync`. `null` = follow the PostHog flag; `true` / `false` =
 * force on / off locally for QA without touching PostHog. Never set from
 * production code — only `ModalTierFrameworkDevSection` / `__heidiModals.tier()`.
 * Session-scoped: resets to `null` on reload.
 */
export const modalTierFrameworkDevOverrideAtom = atom<boolean | null>(null);

/**
 * Per-modal tier verdict. Pure. An unmapped modal passes through (`true`) — see
 * {@link MODAL_TIER_REGISTER} in `modalTierRegister.ts`. `register` is injectable
 * for tests.
 */
export const isModalDisplayAllowedByTier = (
  modalId: ModalId,
  ctx: TierGateContext,
  register: Partial<Record<ModalId, Tier>> = MODAL_TIER_REGISTER
): boolean => {
  const tier = register[modalId];
  if (tier === undefined) return true; // transitional pass-through — end state forbids unassigned
  return evaluateTierGate(tier, ctx).allowed;
};
